// eslint-disable-next-line import/prefer-default-export
export const allPermissions = {
    admin: 'admin',
    adminContainers: 'admin--containers',
    adminAnnouncements: 'admin--announcements',
    adminContainerItemsWithoutContainer: 'admin--container--items-without-container',
    adminCustomization: 'admin--customization',
    adminEmailSettings: 'admin--email-settings',
    adminGlobalSettings: 'admin--global-settings',
    adminGeneral: 'admin--general',
    adminCue: 'admin--cue',
    adminCircuit: 'admin--circuit',
    adminHelp: 'admin--help',
    adminHelpAdd: 'admin--help--add',
    adminHelpEdit: 'admin--help--edit',
    adminHelpDelete: 'admin--help--delete',
    adminLdap: 'admin--ldap',
    adminServers: 'admin--servers',
    adminSsoSettings: 'admin--sso-settings',
    adminServersCalendarConfigs: 'admin--servers--calendar-configs',
    adminServersSsoConfigs: 'admin--servers--sso-configs',
    adminServersLdapServers: 'admin--servers--ldap-servers',
    adminLdapSyncSchedules: 'admin--ldap--sync-schedules',
    adminLdapUserImport: 'admin--ldap--user-import',
    adminLogs: 'admin--logs',
    adminMediaServers: 'admin--media-servers',
    adminMultiDelete: 'admin--multi-delete',
    adminRooms: 'admin--rooms',
    adminRoomsOcr: 'admin--rooms--ocr',
    adminSaml: 'admin--saml',
    adminSoftwareInformation: 'admin--software-information',
    adminTemplates: 'admin--templates',
    adminServersTranscriptionService: 'admin--servers--transcription-service',
    adminUsersAndGroups: 'admin--users-and-groups',
    adminUsersAndGroupsImport: 'admin--users-and-groups--import',
    adminUsersAndGroupsFileImport: 'admin--users-and-groups--file-import',
    adminServersWowza: 'admin--servers--wowza',
    general: 'general',
    generalAlert: 'general--alert',
    generalChangePassword: 'general--change-password',
    generalEditProfile: 'general--edit-profile',
    generalHelp: 'general--help',
    generalHome: 'general--home',
    generalPasswordComplexity: 'general--password-complexity',
    monitoring: 'monitoring',
    monitoringGenerateLink: 'monitoring--generate-link',
    monitoringLockRooms: 'monitoring--lock-rooms',
    monitoringMultiSelect: 'monitoring--multi-select',
    monitoringPtz: 'monitoring--ptz',
    monitoringPtzCanPtzAllAuthors: 'monitoring--ptz--can-ptz-all-authors',
    monitoringPtzEditPresets: 'monitoring--ptz--edit-presets',
    monitoringPtzPtzControl: 'monitoring--ptz--ptz-control',
    monitoringPtzUsePresets: 'monitoring--ptz--use-presets',
    monitoringRecording: 'monitoring--recording',
    monitoringRecordingAddMarkers: 'monitoring--recording--add-markers',
    monitoringRecordingComments: 'monitoring--recording--comments',
    monitoringRecordingCommentsAdd: 'monitoring--recording--comments--add',
    monitoringRecordingCommentsDelete: 'monitoring--recording--comments--delete',
    monitoringRecordingCommentsDeleteAll: 'monitoring--recording--comments--delete-all',
    monitoringRecordingCommentsEdit: 'monitoring--recording--comments--edit',
    monitoringRecordingCommentsEditAll: 'monitoring--recording--comments--edit-all',
    monitoringRecordingCommentsRecordAudio: 'monitoring--recording--comments--record-audio',
    monitoringRecordingEvaluation: 'monitoring--recording--evaluation',
    monitoringRecordingEvaluationViewScores: 'monitoring--recording--evaluation--view-scores',
    monitoringRecordingOptions: 'monitoring--recording--options',
    monitoringRecordingOptionsAllAuthors: 'monitoring--recording--options-all-authors',
    monitoringRecordingPauseAllAuthors: 'monitoring--recording--pause-all-authors',
    monitoringRecordingPauseRecording: 'monitoring--recording--pause-recording',
    monitoringRecordingPrepareRecording: 'monitoring--recording--prepare-recording',
    monitoringRecordingReassignAuthor: 'monitoring--recording--reassign-author',
    monitoringRecordingResumeAllAuthors: 'monitoring--recording--resume-all-authors',
    monitoringRecordingMotionDetection: 'monitoring--recording--motion-detection',
    monitoringRecordingRetention: 'monitoring--recording--retention',
    monitoringRecordingSharing: 'monitoring--recording--sharing',
    monitoringRecordingStartRecording: 'monitoring--recording--start-recording',
    monitoringRecordingStopAllAuthors: 'monitoring--recording--stop-all-authors',
    monitoringRecordingStopConfirmation: 'monitoring--recording--stop-confirmation',
    monitoringSearch: 'monitoring--search',
    monitoringTalkback: 'monitoring--talkback',
    monitoringUnlockAllUsers: 'monitoring--unlock-all-users',
    monitoringViews: 'monitoring--views',
    reports: 'reports',
    reportsAddReport: 'reports--add-report',
    reportsDeleteReport: 'reports--delete-report',
    reportsEditReport: 'reports--edit-report',
    review: 'review',
    reviewIntelligenceTranscriptAdd: 'review--intelligence--transcript--add',
    reviewIntelligenceTranscriptDiarizeAdd: 'review--intelligence--transcript--diarize--add',
    reviewIntelligenceTranscriptDiarizeEdit: 'review--intelligence--transcript--diarize--edit',
    reviewIntelligenceTranscriptDiarizeEditAllAuthors: 'review--intelligence--transcript--diarize--edit--all-authors',
    reviewIntelligenceTranscriptDiarizeDelete: 'review--intelligence--transcript--diarize--delete',
    reviewIntelligenceTranscriptDiarizeDeleteAllAuthors: 'review--intelligence--transcript--diarize--delete--all-authors',
    reviewIntelligenceTranscriptTranslation: 'review--intelligence--transcript--translation',
    reviewIntelligenceTranscriptTranslationAdd: 'review--intelligence--transcript--translation--add',
    reviewIntelligenceTranscriptTranslationEdit: 'review--intelligence--transcript--translation--edit',
    reviewIntelligenceTranscriptTranslationEditAllAuthors: 'review--intelligence--transcript--translation--edit--all-authors',
    reviewIntelligenceTranscriptTranslationDelete: 'review--intelligence--transcript--translation--delete',
    reviewIntelligenceTranscriptTranslationDeleteAllAuthors: 'review--intelligence--transcript--translation--delete--all-authors',
    reviewComments: 'review--comments',
    reviewCommentsAdd: 'review--comments--add',
    reviewCommentsDelete: 'review--comments--delete',
    reviewCommentsDeleteAll: 'review--comments--delete-all',
    reviewCommentsEdit: 'review--comments--edit',
    reviewCommentsEditAll: 'review--comments--edit-all',
    reviewCommentsCommentOverlay: 'review--comments-comment-overlay',
    reviewCommentsRecordAudio: 'review--comments--record-audio',
    reviewDeleteRecordings: 'review--delete-recordings',
    reviewDownloadRecordings: 'review--download-recordings',
    reviewDownloadRecordingsAudioOnly: 'review--download-recordings--audio-only',
    reviewDownloadRecordingsMultiview: 'review--download-recordings--multiview',
    reviewDownloadRecordingsMultiviewAllQueueItems: 'review--download-recordings--multiview--all-queue-items',
    reviewEditInformation: 'review--edit-information',
    reviewEditRetention: 'review--edit-retention',
    reviewEditSharing: 'review--edit-sharing',
    reviewEvaluation: 'review--evaluation',
    reviewEvaluationEdit: 'review--evaluation--edit',
    reviewEvaluationViewScores: 'review--evaluation--view-scores',
    reviewGenerateLink: 'review--generate-link',
    reviewIntelligence: 'review--intelligence',
    reviewIntelligenceOcr: 'review--intelligence--ocr',
    reviewIntelligenceOcrAdd: 'review--intelligence--ocr--add',
    reviewIntelligenceOcrAuto: 'review--intelligence--ocr--auto',
    reviewIntelligenceOcrDelete: 'review--intelligence--ocr--delete',
    reviewIntelligenceKeywordFlagging: 'review--intelligence--keyword-flagging',
    reviewIntelligenceKeywordFlaggingAdd: 'review--intelligence--keyword-flagging--add',
    reviewIntelligenceKeywordFlaggingEdit: 'review--intelligence--keyword-flagging--edit',
    reviewIntelligenceKeywordFlaggingEditAllAuthors: 'review--intelligence--keyword-flagging--edit--all-authors',
    reviewIntelligenceKeywordFlaggingDelete: 'review--intelligence--keyword-flagging--delete',
    reviewIntelligenceKeywordFlaggingDeleteAllAuthors: 'review--intelligence--keyword-flagging--delete--all-authors',
    reviewIntelligenceCommentIntelligence: 'review--intelligence--comment-intelligence',
    reviewIntelligenceCommentIntelligenceAdd: 'review--intelligence--comment-intelligence--add',
    reviewIntelligenceCommentIntelligenceEdit: 'review--intelligence--comment-intelligence--edit',
    reviewIntelligenceCommentIntelligenceEditAllAuthors: 'review--intelligence--comment-intelligence--edit--all-authors',
    reviewIntelligenceCommentIntelligenceDelete: 'review--intelligence--comment-intelligence--delete',
    reviewIntelligenceCommentIntelligenceDeleteAllAuthors: 'review--intelligence--comment-intelligence--delete--all-authors',
    reviewIntelligenceSummary: 'review--intelligence--summary',
    reviewIntelligenceSummaryAdd: 'review--intelligence--summary--add',
    reviewIntelligenceSummaryEdit: 'review--intelligence--summary--edit',
    reviewIntelligenceSummaryEditAllAuthors: 'review--intelligence--summary--edit--all-authors',
    reviewIntelligenceSummaryDelete: 'review--intelligence--summary--delete',
    reviewIntelligenceSummaryDeleteAllAuthors: 'review--intelligence--summary--delete--all-authors',
    reviewIntelligenceSentiment: 'review--intelligence--sentiment',
    reviewIntelligenceSentimentAdd: 'review--intelligence--sentiment--add',
    reviewIntelligenceSentimentEdit: 'review--intelligence--sentiment--edit',
    reviewIntelligenceSentimentEditAllAuthors: 'review--intelligence--sentiment--edit--all-authors',
    reviewIntelligenceSentimentDelete: 'review--intelligence--sentiment--delete',
    reviewIntelligenceSentimentDeleteAllAuthors: 'review--intelligence--sentiment--delete--all-authors',
    reviewIntelligenceDysfluency: 'review--intelligence--dysfluency',
    reviewIntelligenceDysfluencyAuto: 'review--intelligence--dysfluency--auto',
    reviewIntelligenceDysfluencyDelete: 'review--intelligence--dysfluency--delete',
    reviewMarkers: 'review--markers',
    reviewMarkersAddMarkers: 'review--markers--add-markers',
    reviewMarkersDeleteMarkers: 'review--markers--delete-markers',
    reviewMarkersEditMarkers: 'review--markers--edit-markers',
    reviewMarkersMarkerOverlay: 'review--markers--marker-overlay',
    reviewMarkersSeeAll: 'review--markers--see-all',
    reviewPlaylistAdd: 'review--playlist--add',
    reviewReassignAuthor: 'review--reassign-author',
    reviewTools: 'review--tools',
    reviewToolsClip: 'review--tools--clip',
    reviewToolsRedact: 'review--tools--redact',
    reviewZoom: 'review--zoom',
    schedule: 'schedule',
    scheduleAddSchedule: 'schedule--add-schedule',
    scheduleChangeAuthor: 'schedule--change-author',
    scheduleControl: 'schedule--control',
    scheduleEditSchedules: 'schedule--edit-schedules',
    scheduleEditAllSchedules: 'schedule--edit-all-schedules',
    scheduleCopySchedules: 'schedule--copy-schedules',
    scheduleCopyAllSchedules: 'schedule--copy-all-schedules',
    scheduleDeleteAndRemoveSchedules: 'schedule--delete-and-remove-schedules',
    scheduleDeleteAndRemoveAllSchedules: 'schedule--delete-and-remove-all-schedules',
    scheduleExceptions: 'schedule--exceptions',
    scheduleRetention: 'schedule--retention',
    scheduleSharing: 'schedule--sharing',
    upload: 'upload',
    uploadAuthor: 'upload--author',
    uploadRetention: 'upload--retention',
    uploadSharing: 'upload--sharing',
};
